import React from "react";
import Rails from 'rails-ujs';
import Cleave from 'cleave.js/react';
import axios from 'axios';
import ReviewNotes from './ReviewNotes.js';
import classnames from 'classnames';

class NewCardUnivaPayFields extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      errorMessage: null,
      errorCode: null,
    }

    this.univaPayFormRef = React.createRef();
    this.trySubmit = this.trySubmit.bind(this);
    this.createCard = this.createCard.bind(this);
    this.univaPayCheckout = window.UnivapayCheckout;
  }

  async trySubmit(e) {
    const { setIsLoading, setNewUserCard } = this.props;

    // Show loader and freeze the form
    e.preventDefault();
    setIsLoading(true);

    let tokenResult;
    try {
      tokenResult = await this.univaPayCheckout.submit(this.univaPayFormRef.current);
      console.log('UnivaPay token result:', tokenResult);
    } catch (e) {
      this.setState({
        errorMessage: 'エラーが発生しました',
        errorCode: e.message
      });
      setIsLoading(false);
      return;
    }

    const createdCard = await this.createCard(tokenResult.tokenData);

    if(createdCard) {
      setNewUserCard({ userCardUid: createdCard.uid });
    } else {
      setIsLoading(false);
    }
  }

  async createCard (tokenData) {
    console.log(tokenData);
    const requestBody = {
      token: tokenData.id,
      exp_month: tokenData.data.card.expMonth,
      exp_year: tokenData.data.card.expYear,
      last4: tokenData.data.card.lastFour,
      brand: tokenData.data.card.brand,
    };
    const headers = { 'X-CSRF-Token': Rails.csrfToken() };

    try {
      const response = await axios.post(
        '/univa_pay_user_cards', requestBody, { headers: headers, timeout: 25000 }
      );
      if(response.status !== 201) {
        throw new Error(JSON.stringify(response.data));
      }
      return({
        uid: response.data.uid
      });

    } catch (error) {
      this.setState({
        errorMessage: [
          'エラーが発生しました。購入は完了していません。',
          'カード情報を確認してください。すでに登録済みのカードは、再登録できません。',
          '問題が解決しない場合は、カード情報を消してからこの画面のスクリーンショットを取って、カスタマーサポートまでお問い合わせください。'
        ].join(''),
        errorCode: error.message
      });
      return(false);
    }
  }

  render () {
    const { isLoading, backPath, customSubmitBtnLabel, tdsBackUpUrl } = this.props;
    const {
      errorMessage,
      errorCode,
    } = this.state;

    const isEveryNameFieldValid = true; // nameFirst.length !== 0 && nameLast.length !== 0;

    return(
      <React.Fragment>
        <hr />
        <h4>新しいクレジットカードを登録</h4>
        {errorMessage && <div className="alert alert-danger">
          <p>{errorMessage}</p>
          {errorCode && <code>{errorCode}</code>}
        </div>}

        <div className="row">
          <div className={classnames(this.props.fieldColClassNames)}>
            <form ref={this.univaPayFormRef}>
              <div
                data-app-id={this.props.univaPayAppToken}
                data-checkout="token"
                data-inline="true"
                data-inline-text-field-style="height: 48px; padding: 6px 16px; font-size: 20px;"
                data-payment-methods="card"
                data-token-type="recurring"
                data-email={this.props.email}
                data-phone-number={this.props.tel}
                data-locale="ja"
              />
            </form>
          </div>
        </div>

        <ReviewNotes tdsBackUpUrl={tdsBackUpUrl} />
        <div className="d-flex justify-content-between">
          {!!backPath &&
            <a className="btn btn-lg btn-outline-secondary" href={backPath} disabled={isLoading}>戻る</a>}
          <button className="btn btn-lg btn-primary"
            disabled={isLoading || !isEveryNameFieldValid}
            onClick={this.trySubmit}
          >
            {isLoading ? '処理中です' : (!!customSubmitBtnLabel ? customSubmitBtnLabel : '商品をご購入')}
          </button>
        </div>
      </React.Fragment>
    )
  }
}

export default NewCardUnivaPayFields;
